module.exports = __webpack_public_path__ + "img/744.2ccc9823.jpg";